var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0526 10.1738L12.6426 11.5838L17.2226 16.1738L12.6426 20.7638L14.0526 22.1738L20.0526 16.1738L14.0526 10.1738Z",
    fill: "#8AA5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.347656,
    y: 0.173828,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#546A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevRightBlue);
export default __webpack_public_path__ + "static/media/chev_right_blue.0a6660a7afc9e2467bfe092aa9e57e06.svg";
export { ForwardRef as ReactComponent };